import React from 'react';
import { decamelize, camelize } from 'humps';

/**
 * @param {string} str
 */
export const capitalize = (str) => {
  if (typeof str !== 'string') return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * @param {string} str 'Hello World Foo Bar.' -> 'hello-world-foo-bar'
 */
export const slugify = (str) =>
  decamelize(camelize(str.replace(/[^\w\s]|_/g, ' ').replace(/\s+/g, ' ')), {
    split: /(?=[A-Z0-9])/, // Treat numbers as capital letters
    separator: '-',
  });

/**
 * @param {string} text
 * @param {string|CSSModule Reference} className
 * @return {array[node]}
 */
export const withParagraphs = (text, className = null) =>
  (text &&
    typeof text === 'string' &&
    text.split('\n').map((paragraph, index) => (
      <p key={index} className={className}>
        {paragraph}
      </p>
    ))) ||
  text;

/**
 * @return {string} "0f1742njbehb5jlngzsgr0s"
 */
export const randomHash = () =>
  Math.random()
    .toString(36)
    .substring(2, 15) +
  Math.random()
    .toString(36)
    .substring(2, 15);

/**
 * @param {string} str from: "title case" to "Title Case" Helper
 */
export const toTitleCase = (str) =>
  str.replace(
    /\w\S*/g,
    (text) => text.charAt(0).toUpperCase() + text.substr(1).toLowerCase()
  );

/**
 * @param {string} str from: "snake_case" to "Capitalized Case" Helper
 */
export const unslugifyAndCapitalize = (str = '') => {
  const len = str.length - 1;
  let i = 0;
  let val = '';
  while (i <= len) {
    if (i == 0 || (i > 0 && str[i - 1] === '_')) {
      val += str[i].toUpperCase();
    } else {
      val += str[i] === '_' ? ' ' : str[i];
    }
    i += 1;
  }
  return val;
};

/**
 * @param {string} str from: "normal case" to "snake_case" Helper
 */

export const snakeCase = (string = '') =>
  string
    .toLowerCase()
    .match(/2,(?=[a-z]+[0-9]*|\b)|[a-z]+[0-9]*|[0-9]+/g)
    ?.join('_') || '';

export const wordCount = (string = '') => {
  return string ? string.trim().split(/\s+/).length : 0;
};
